var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.formValue)?_c('json-schema-form',{attrs:{"value":_vm.formValue},on:{"submit":_vm.submitHandler}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/pages/jschemas/edit.vue?vue&type=template&id=7309e343&
// module id = null
// module chunks = 